import { Button } from "components/DesignSystem/Button/Button";
import { OPEN_ITEMS_CARD_OPENED } from "constants/analyticsEvents";
import { useAnalytics } from "hooks/useAnalytics";
import { useDispatch } from "react-redux";
import { openCalrifyModal } from "store/slices/openItem";
import { OpenItemStatus } from "types/Models/openItem";

type OpenItemCTAProps = {
  customData: { status: OpenItemStatus; header: string; csv_id: string };
  messageId: string;
  size?: "regular" | "block";
  closeActionItem?: () => void;
  completed?: boolean;
  btnType?: "primary" | "secondary";
};

export const OpenItemCTA = ({
  customData,
  messageId,
  completed,
  btnType,
}: OpenItemCTAProps) => {
  const dispatch = useDispatch();
  const { status, csv_id } = customData;
  const { trackEvent } = useAnalytics();
  const isClarified = status === "SUBMITTED" || completed;

  const openClarifyModal = () => {
    trackEvent(OPEN_ITEMS_CARD_OPENED);
    dispatch(openCalrifyModal({ csvId: csv_id, messageId: messageId, status }));
  };

  return (
    <Button
      customType={btnType || isClarified ? "secondary" : "primary"}
      onClick={openClarifyModal}
      size="small"
    >
      {isClarified ? "View" : "Clarify"}
    </Button>
  );
};
